import Axios from 'axios'
import { parseAuthenticationHeader } from 'helpers/Functions'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/pinned-key-metrics`

export type TPinnedKeyMetricBody = {
  comment: string
  key_metric_id: string
  group_id?: string
}

export type TPinnedKeyMetricPatchBody = {
  comment?: string
  group_id?: string
}

export type TPinnedKeyMetricResponse = {
  id: string
  comment: string | null
  group_id: string | null
  key_metric_id: string
}

export async function create(body: TPinnedKeyMetricBody) {
  return Axios.post<{ data: TPinnedKeyMetricResponse }>(
    URL,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function update(id: string, body: TPinnedKeyMetricPatchBody) {
  return Axios.patch<{ data: TPinnedKeyMetricResponse }>(
    `${URL}/${id}`,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
